import React, { useState, useEffect, useRef } from "react";

import BcSepIcon  from "../../asset/images/about/breadcrumb-separator.svg";
import CheckIcon  from "../../asset/images/products/value-added/check-icon.svg";
import ThumbsIcon from "../../asset/images/products/value-added/thumbs-icon.svg";

// Desktop + Mobile hero images — imported separately
import HeroBgImg       from "../../asset/images/products/value-added/hero-bg.webp";
import HeroBgImgMobile from "../../asset/images/products/value-added/hero-bg-mobile.webp";

// Section 1 — ESP R&M image
import EspRmImg from "../../asset/images/products/value-added/esp-rm.webp";

// Section 3 — Retrofits image
import RetrofitsImg from "../../asset/images/products/value-added/retrofits.webp";

// Section 4 — Service & Repair slider images
import SlideImg1 from "../../asset/images/products/value-added/slide-1.webp";
import SlideImg2 from "../../asset/images/products/value-added/slide-2.webp";
import SlideImg3 from "../../asset/images/products/value-added/slide-3.webp";


const SLIDES = [SlideImg1, SlideImg2, SlideImg3];
const AUTOPLAY_SPEED = 10000;

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .vas-wrap { font-family: 'Poppins', sans-serif; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .vas-hero {
    position: relative;
    width: 100%;
    height: 460px;
    overflow: hidden;
    background: #111;
  }
  .vas-hero-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }
  .vas-hero-bg-mobile {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: none;
  }
  .vas-hero-overlay { position: absolute; inset: 0; }
  .vas-hero-content {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 102px;
    max-width: 1600px;
    margin: 0 auto;
    left: 0; right: 0;
  }
  .vas-hero-title {
    font-size: 42px;
    font-weight: 700;
    color: #fff;
    line-height: 120%;
    margin-bottom: 15px;
  }
  .vas-hero-divider {
    width: 473px;
    height: 2px;
    background: #EB2019;
    border: none;
  }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .vas-breadcrumb { padding: 40px 0 0 0; }
  .vas-breadcrumb-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
  }
  .vas-bc-item {
    font-size: 16px;
    font-weight: 500;
    color: #202020;
    text-decoration: none;
    transition: color 0.15s;
  }
  .vas-bc-item:hover { color: #EB2019; }
  .vas-bc-item.vas-active { color: #202020; }
  .vas-bc-sep {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin: 0 8px;
    flex-shrink: 0;
  }

  /* ══════════════════════════════════════════
     SHARED INNER
  ══════════════════════════════════════════ */
  .vas-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 144px;
  }

  /* ══════════════════════════════════════════
     SHARED — CARD with border
  ══════════════════════════════════════════ */
  .vas-card {
    border-radius: 10px;
    padding:  71px 44.5px;
    background: #fff;
       box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.10);
  }
       .vas-card2 {
    border-radius: 10px;
    padding:  44px;
    background: #fff;
       box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.10);
  }

  /* ══════════════════════════════════════════
     SHARED — RED SECTION DIVIDER
  ══════════════════════════════════════════ */
  .vas-section-divider {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }
  .vas-section-divider hr {
    border: none;
    border-top: 1px solid #EB2019;
    opacity: 0.3;
  }

  /* ══════════════════════════════════════════
     SHARED — RED TITLE inside card
  ══════════════════════════════════════════ */
  .vas-card-red-label {
    font-size: 20px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 1px;
  }
  .vas-card-red-title {
    font-size: 20px;
    font-weight: 600;
    color: #EB2019;
    margin-bottom: 24px;
  }
  .vas-card-bold-title {
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 24px;
  }

  /* ══════════════════════════════════════════
     SHARED — CHECKMARK BULLET LIST
  ══════════════════════════════════════════ */
  .vas-check-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  .vas-check-item {
    display: flex;
    gap: 13px;
    align-items: flex-start;
  }
  .vas-check-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    margin-top: 2px;
  }
  .vas-check-text {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
  }

  /* ══════════════════════════════════════════
     SECTION 1 — ESP R&M
     left: image | right: card
  ══════════════════════════════════════════ */
  .vas-section-1 {
    padding: 80px 0 80px 0;
  }
  .vas-s1-grid {
    display: flex;
    gap: 64px;
    align-items: center;
  }
  .vas-s1-img-wrap {
    flex: 0 0 683px;
    border-radius: 10px;
    overflow: hidden;
  }
  .vas-s1-img {
    width: 100%;
    height: 370px;
    object-fit: cover;
    display: block;
  }
  .vas-s1-card {
    flex: 1;
  }

  /* ══════════════════════════════════════════
     SECTION 2 — NISCHINT CARE
     small card left-aligned ~40% width
  ══════════════════════════════════════════ */
  .vas-section-2 {
    padding: 80px 0 80px 0;
  }
  .vas-s2-card {
    max-width: 460px;
  }
    .vas-s2-card2 {
    max-width: 474px;
  }
  .vas-s2-title {
    font-size: 20px;
    font-weight: 600;
    color: #202020;
    margin-bottom: 24px;
    letter-spacing: 0.02em;
  }
  .vas-s2-thumbs {
    width: 44px;
    height: 44px;
    display: block;
    margin-bottom: 24px;
  }
  .vas-s2-link {
    font-size: 14px;
    font-weight: 400;
    color: #202020;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .vas-s2-link:hover { text-decoration: underline; }

  /* ══════════════════════════════════════════
     SECTION 3 — RETROFITS
     left: card | right: image
  ══════════════════════════════════════════ */
  .vas-section-3 {
    padding: 80px 0 80px 0;
  }
  .vas-s3-grid {
    display: flex;
    gap: 64px;
    align-items: flex-start;
  }
  .vas-s3-card {
    flex: 0 0 564px;
  }
  .vas-s3-img-wrap {
    flex: 1;
    border-radius: 0;
    overflow: hidden;
  }
  .vas-s3-img {
    width: 100%;
    height: 370px;
    object-fit: cover;
    display: block;
    border-radius: 10px;
  }

  /* ══════════════════════════════════════════
     SECTION 4 — SERVICE & REPAIR
     left: slider | right: card
  ══════════════════════════════════════════ */
  .vas-section-4 {
    padding: 80px 0 120px 0;
  }
  .vas-s4-grid {
    display: flex;
    gap: 64px;
    align-items: flex-start;
  }

  /* Slider */
  .vas-slider {
    flex: 0 0 683px;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .vas-slider-img-wrap {
    width: 100%;
    height: 369px;
    border-radius: 10px;
    overflow: hidden;
    cursor: grab;
    user-select: none;
  }
  .vas-slider-img-wrap:active { cursor: grabbing; }
  .vas-slider-track {
    display: flex;
    height: 100%;
    transition: transform 0.6s ease;
  }
  .vas-slider-track .vas-slider-img { min-width: 100%; flex-shrink: 0; }
  .vas-slider-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .vas-slider-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
  .vas-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #B8B7B7;
    border: none;
    cursor: pointer;
    padding: 0;
    transition: background 0.2s;
  }
  .vas-dot.vas-dot-active { background: #EB2019; }

  /* Service & Repair card */
  .vas-s4-card {
    flex: 1;
  }
  .vas-s4-para {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    line-height: 160%;
    margin-bottom: 18px;
  }
  .vas-s4-link {
    font-size: 16px;
    font-weight: 400;
    color: #202020;
    text-decoration: none;
  }
  .vas-s4-link:hover { color: #EB2019; }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET 768px
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .vas-hero              { height: 300px; }
    .vas-hero-bg           { display: block; }
    .vas-hero-bg-mobile    { display: none; }
    .vas-hero-content      { padding: 0 32px; }
    .vas-hero-title        { font-size: 30px; }
    .vas-hero-divider      { width: 260px; }

    .vas-breadcrumb        { padding: 28px 0 0 0; }
    .vas-breadcrumb-inner  { padding: 0 32px; }
    .vas-inner             { padding: 0 32px; }
    .vas-section-divider   { padding: 0 32px; }

    .vas-section-1         { padding: 40px 0 40px 0; }
    .vas-s1-grid           { flex-direction: column; gap: 30px; }
    .vas-s1-img-wrap       { flex: none; width: 100%; }
    .vas-s1-img            { height: 260px; }
    .vas-card-bold-title {     margin-bottom: 20px;}

    .vas-section-2         { padding: 40px 0 40px 0; }
    .vas-s2-card2           { max-width: 100%; }
    .vas-s2-card2 { padding: 28px 28px;}

    .vas-section-3         { padding: 40px 0 40px 0; }
    
.vas-card-red-title { margin-bottom: 20px;}
    .vas-s3-grid           { flex-direction: column-reverse; gap: 24px; }
    .vas-check-icon { width: 20px;     height: 20px;}
    .vas-check-list { gap: 16px;}
    .vas-s3-img-wrap {  width: 100%;}
    .vas-s3-card           { flex: none; width: 100%; }
    .vas-s3-img            { height: 260px;width:100%; }

    .vas-section-4         { padding: 40px 0 60px 0; }
    .vas-s4-grid           { flex-direction: column; gap: 24px; }
    .vas-slider            { flex: none; width: 100%; }
    .vas-slider-img-wrap   { height: 260px; }

    .vas-card              { padding: 28px 28px; width:100%; }
    .vas-check-text        { font-size: 14px; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE 480px
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .vas-hero              { height: 400px; }
    .vas-hero-bg           { display: none; }
    .vas-hero-bg-mobile    { display: block; }
    .vas-hero-content      { padding: 0 16px; }
    .vas-hero-title        { font-size: 24px; }
    .vas-hero-divider      { width: 100%; }

    .vas-breadcrumb        { padding: 22px 0 0 0; }
    .vas-breadcrumb-inner  { padding: 0 16px; gap: 16px; }
    .vas-bc-item           { font-size: 14px; }
    .vas-bc-sep            { width: 18px; height: 18px; margin: 0 4px; }
    .vas-inner             { padding: 0 16px; }
    .vas-section-divider   { padding: 0 16px; }

    .vas-section-1         { padding: 60px 0 60px 0; }
    .vas-s1-img            { height: 195px; }

    .vas-section-2         { padding: 60px 0 60px 0; }
        .vas-s2-card2 {         padding: 31px 16px;}

    .vas-section-3         { padding: 60px 0 60px 0; }
    .vas-s3-img            { height: 195px; }
    .vas-s3-grid { gap:30px;}

    .vas-section-4         { padding: 60px 0 60px 0; }
    .vas-slider-img-wrap   { height: 195px; }
    .vas-dot               { width: 6px; height: 6px; }
        .vas-s4-grid { gap:14px;}

    .vas-card              { padding: 33.5px 30px; }
    .vas-card-red-title    { font-size: 20px;  margin-bottom: 24px; }
    .vas-card-bold-title   { font-size: 20px; margin-bottom: 24px;}
    .vas-check-text        { font-size: 14px; }
        .vas-check-list {         gap: 24px;}
    .vas-s4-para           { font-size: 14px;  margin-bottom: 15px;}
    .vas-s4-link           { font-size: 14px; }
  }
`;

export default function ValueAddedServices() {
  const [activeSlide, setActiveSlide] = useState(0);
  const intervalRef = useRef(null);
  const dragStartX  = useRef(null);

  /* ── Autoplay ── */
  const stopAutoplay = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  const startAutoplay = () => {
    stopAutoplay();
    intervalRef.current = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % SLIDES.length);
    }, AUTOPLAY_SPEED);
  };
  useEffect(() => {
    startAutoplay();
    return () => stopAutoplay();
  }, []);

  /* ── Dot click ── */
  const goToSlide = (i) => {
    stopAutoplay();
    setActiveSlide(i);
    startAutoplay();
  };

  /* ── Drag / swipe ── */
  const onDragStart = (e) => {
    dragStartX.current = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    stopAutoplay();
  };
  const onDragEnd = (e) => {
    if (dragStartX.current === null) return;
    const endX = e.type === "touchend" ? e.changedTouches[0].clientX : e.clientX;
    const diff  = dragStartX.current - endX;
    if (Math.abs(diff) > 80) {
      setActiveSlide(prev =>
        diff > 0
          ? (prev + 1) % SLIDES.length
          : (prev - 1 + SLIDES.length) % SLIDES.length
      );
    }
    dragStartX.current = null;
    startAutoplay();
  };

  return (
    <div className="vas-wrap">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="vas-hero">
        <img className="vas-hero-bg"        src={HeroBgImg}       alt="" />
        <img className="vas-hero-bg-mobile" src={HeroBgImgMobile} alt="" />
        <div className="vas-hero-overlay" />
        <div className="vas-hero-content">
          <h1 className="vas-hero-title">Value Added Services</h1>
          <hr className="vas-hero-divider" />
        </div>
      </section>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="vas-breadcrumb" aria-label="Breadcrumb">
        <div className="vas-breadcrumb-inner">
          <a href="/" className="vas-bc-item">Home</a>
          <span className="vas-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/products" className="vas-bc-item">Products</a>
          <span className="vas-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="vas-bc-item vas-active">Value Added Services</span>
        </div>
      </nav>

      {/* ══ SECTION 1 — ESP R&M ══ */}
      <section className="vas-section-1">
        <div className="vas-inner">
          <div className="vas-s1-grid">

            {/* Left — image */}
            <div className="vas-s1-img-wrap">
              <img className="vas-s1-img" src={EspRmImg} alt="ESP R&M Electromechanical" />
            </div>

            {/* Right — card */}
            <div className="vas-s1-card vas-card">
              <p className="vas-card-red-label">ESP R&amp; M</p>
              <h2 className="vas-card-bold-title">Electromechanical</h2>
              <ul className="vas-check-list">
                <li className="vas-check-item">
                  <img src={CheckIcon} alt="" className="vas-check-icon" />
                  <span className="vas-check-text">Ador can provide electromechanical solution for mid life upgrade of ESP</span>
                </li>
                <li className="vas-check-item">
                  <img src={CheckIcon} alt="" className="vas-check-icon" />
                  <span className="vas-check-text">We have more than 10 capable engineers in India to provide suitable electromechanical solution for any kind of ESP process</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="vas-section-divider"><hr /></div>

      {/* ══ SECTION 2 — NISCHINT CARE ══ */}
      <section className="vas-section-2">
        <div className="vas-inner">
          <div className="vas-s2-card2 vas-card2">
            <h3 className="vas-s2-title">NISCHINT CARE</h3>
            <img src={ThumbsIcon} alt="" className="vas-s2-thumbs" />
            <a href="#" className="vas-s2-link">CLICK HERE TO MAKE YOUR LIFE EASY WITH ADOR .</a>
          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="vas-section-divider"><hr /></div>

      {/* ══ SECTION 3 — RETROFITS ══ */}
      <section className="vas-section-3">
        <div className="vas-inner">
          <div className="vas-s3-grid">

            {/* Left — card */}
            <div className="vas-s3-card vas-card">
              <h2 className="vas-card-red-title">Retrofits</h2>
              <ul className="vas-check-list">
                <li className="vas-check-item">
                  <img src={CheckIcon} alt="" className="vas-check-icon" />
                  <span className="vas-check-text">Ador has retrofitted the controllers of nearly 500+ sites in India</span>
                </li>
                <li className="vas-check-item">
                  <img src={CheckIcon} alt="" className="vas-check-icon" />
                  <span className="vas-check-text">Our retrofit solutions are fit and forget</span>
                </li>
                <li className="vas-check-item">
                  <img src={CheckIcon} alt="" className="vas-check-icon" />
                  <span className="vas-check-text">We have capability and credentials of retrofitting all controllers in India including all Chinese controller for providing a good mid life upgrade</span>
                </li>
              </ul>
            </div>

            {/* Right — image */}
            <div className="vas-s3-img-wrap">
              <img className="vas-s3-img" src={RetrofitsImg} alt="Retrofits" />
            </div>

          </div>
        </div>
      </section>

      {/* ══ DIVIDER ══ */}
      <div className="vas-section-divider"><hr /></div>

      {/* ══ SECTION 4 — SERVICE & REPAIR ══ */}
      <section className="vas-section-4">
        <div className="vas-inner">
          <div className="vas-s4-grid">

            {/* Left — slider */}
            <div className="vas-slider">
              <div
                className="vas-slider-img-wrap"
                onMouseDown={onDragStart}
                onMouseUp={onDragEnd}
                onMouseLeave={() => { dragStartX.current = null; startAutoplay(); }}
                onTouchStart={onDragStart}
                onTouchEnd={onDragEnd}
              >
                <div
                  className="vas-slider-track"
                  style={{ transform: `translateX(-${activeSlide * 100}%)` }}
                >
                  {SLIDES.map((src, i) => (
                    <img
                      key={i}
                      className="vas-slider-img"
                      src={src}
                      alt={`Service slide ${i + 1}`}
                      draggable={false}
                    />
                  ))}
                </div>
              </div>
              <div className="vas-slider-dots">
                {SLIDES.map((_, i) => (
                  <button
                    key={i}
                    className={`vas-dot${activeSlide === i ? " vas-dot-active" : ""}`}
                    onClick={() => goToSlide(i)}
                    aria-label={`Slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            {/* Right — card */}
            <div className="vas-s4-card vas-card">
              <h2 className="vas-card-red-title">Service &amp; Repair</h2>
              <p className="vas-s4-para">We won't stop till we answer all your questions!</p>
              <a href="#" className="vas-s4-link">Get all the Help &amp; Support</a>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}